// extracted by css-extract-rspack-plugin
export default {"topicLabel":"TopicLabel-module__topicLabel__WAFkQ"};